import OptionsPanel from "./OptionsPanel"
import Color from "./Color"

export default class FontColor extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Font Color" // TODO: This needs to be localized
    this.setting = "fontColor"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
